module.exports = __webpack_public_path__ + "img/IT.27fe7edc.svg";